import { createLiveChatClicked, createLiveChatEnded, createLiveChatStarted } from '@/events/LiveChatEvents'
import { TrackLiveChatStartedInput } from '@/types'
import { useAnalytics } from './AnalyticsHook'
import { hashValue } from '@/helpers/AnalyticsSegmentHelper'

export const useLiveChatClicked = () => {
  const analytics = useAnalytics()

  const trackLiveChatClicked = (): void => {
    const eventProps = createLiveChatClicked()

    analytics.trackEvent(eventProps)
  }

  return trackLiveChatClicked
}

export const useLiveChatStarted = () => {
  const analytics = useAnalytics()

  const trackLiveChatStarted = ({ email, firstName, lastName }: TrackLiveChatStartedInput): void => {
    const eventProps = createLiveChatStarted({
      email: hashValue(email),
      firstName: hashValue(firstName),
      lastName: hashValue(lastName),
    })

    analytics.trackEvent(eventProps)
  }

  return trackLiveChatStarted
}

export const useLiveChatEnded = () => {
  const analytics = useAnalytics()

  const trackLiveChatEnded = (): void => {
    const eventProps = createLiveChatEnded()

    analytics.trackEvent(eventProps)
  }

  return trackLiveChatEnded
}
